/* Native content disclosures and shared FAQ layout. */
(()=>{
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const animations=new WeakMap();
 function upgradeFaqs(root){
  root.querySelectorAll('#MainContent h1,#MainContent h2,#MainContent h3').forEach(heading=>{
   if(!/^(Vanliga frågor|Frågor och svar|Ofte stillede spørgsmål|Spørgsmål og svar)/i.test(heading.textContent.trim())||heading.closest('[data-ml-faq]'))return;
   let source=heading.parentElement;
   const selector='details,[data-native-accordion],.mx-accordion-item_header';
   while(source&&source.id!=='MainContent'&&source.querySelectorAll(selector).length<2)source=source.parentElement;
   if(!source||source.id==='MainContent')return;
   const items=[...source.querySelectorAll(selector)].map(control=>{
    const trigger=control.matches('details')?control.querySelector(':scope > summary'):control;
    const panel=control.matches('details')?control:control.matches('[data-native-accordion]')?document.getElementById(control.dataset.nativeAccordion):control.closest('.mx-accordion-item')?.querySelector('.mx-accordion-item_body');
    if(!trigger||!panel)return null;
    const label=trigger.cloneNode(true);label.querySelectorAll('svg,.nr-accordion-item_icon,.mx-accordion-item_icon').forEach(icon=>icon.remove());
    return {label:label.textContent.trim(),panel,trigger,open:control.matches('details')?control.open:trigger.getAttribute('aria-expanded')==='true',id:control.matches('details')?control.id:''};
   }).filter(Boolean);
   if(items.length<2)return;
   const section=document.createElement('section');section.className='ml-faq';section.dataset.mlFaq='';section.id=source.id;
   if(source.matches('div,mx-row'))section.classList.add('ml-faq-contained');
   const intro=document.createElement('div');intro.className='ml-faq-intro';
   const title=document.createElement('h2');title.textContent='Ofte stillede spørgsmål';title.id=heading.id;
   const help=document.createElement('p');help.textContent='Kan du ikke finde svaret? Vi hjælper dig gerne.';
   const link=document.createElement('a');link.href='/pages/kontakt';link.className='ml-faq-contact';link.textContent='Kontakt os';
   const image=document.createElement('img');image.src='https://cdn.shopify.com/s/files/1/0887/6182/7658/files/faq.webp?width=600';image.width=600;image.height=600;image.alt='Vi hjælper dig gerne';image.loading='lazy';image.decoding='async';
   intro.append(title,help,link,image);
   const questions=document.createElement('div');questions.className='ml-faq-questions';
   items.forEach(item=>{
    const details=document.createElement('details');details.className='ml-faq-item';details.open=item.open;details.id=item.id;
    const summary=document.createElement('summary');summary.textContent=item.label;
    const icon=document.createElementNS('http://www.w3.org/2000/svg','svg');icon.setAttribute('viewBox','0 0 20 20');icon.setAttribute('aria-hidden','true');icon.innerHTML='<path d="m6 8 4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>';summary.append(icon);
    const answer=document.createElement('div');answer.className='ml-faq-answer';if(item.panel!==item.trigger&&item.panel.tagName!=='DETAILS')answer.id=item.panel.id;
    const content=[...item.panel.childNodes].filter(node=>node!==item.trigger);
    const elements=content.filter(node=>node.nodeType===1);
    const wrapper=elements.length===1&&elements[0].matches('.nx-prose,.nr-accordion-item_body-inner,.mx-accordion-item_body-inner')?elements[0]:null;
    answer.append(...(wrapper?[...wrapper.childNodes]:content));
    details.append(summary,answer);questions.append(details);
   });
   section.append(intro,questions);
   // Remove the old FAQ background and spacing from its wrapping rows as well.
   const shell=source.closest('section');
   if(shell&&shell!==source&&shell.querySelectorAll('h1,h2,h3').length===1){
    for(let node=source.parentElement;node;node=node.parentElement){node.dataset.mlFaqShell=node===shell?'outer':'inner';if(node===shell)break;}
   }
   source.replaceWith(section);
  });
 }
 function animate(element,from,to,finish){
  const previous=animations.get(element);if(previous){previous.onfinish=null;previous.cancel();}
  if(reduced.matches||!element.animate||Math.abs(from-to)<1){finish();return;}
  const overflow=element.style.overflow;
  element.style.overflow='hidden';
  const animation=element.animate([{height:from+'px'},{height:to+'px'}],{duration:240,easing:'cubic-bezier(.22,1,.36,1)'});
  animations.set(element,animation);
  animation.onfinish=()=>{if(animations.get(element)!==animation)return;animations.delete(element);element.style.overflow=overflow;finish();};
 }
 function markReviewShells(root){
  root.querySelectorAll('.nx-rating:has(.max365-native-summary)').forEach(rating=>{
   for(let node=rating.parentElement,i=0;node&&i<3;i++,node=node.parentElement){
    if(node.children.length!==1||node.textContent.trim()!==rating.textContent.trim())break;
    node.dataset.mlReviewShell='';
   }
  });
 }
 function upgradeVariantChoices(root){
  root.querySelectorAll('#MainContent select[name="id"]:not([data-ml-choices])').forEach(select=>{
   if(select.hidden||select.options.length<2||select.closest('[hidden]')||getComputedStyle(select).display==='none')return;
   select.dataset.mlChoices='';
   const label=select.id?[...root.querySelectorAll('label')].find(el=>el.htmlFor===select.id):null;
   const field=document.createElement('fieldset');field.className='ml-variant-choices';
   const legend=document.createElement('legend');legend.textContent=label?.textContent.trim()||'Vælg variant';field.append(legend);
   const choices=document.createElement('div');choices.className='ml-variant-grid';choices.setAttribute('role','radiogroup');choices.setAttribute('aria-label',legend.textContent);field.append(choices);
   const buttons=[...select.options].map(option=>{
    const button=document.createElement('button');button.type='button';button.setAttribute('role','radio');button.textContent=option.textContent.trim();button.dataset.variant=option.value;
    button.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));});
    choices.append(button);return button;
   });
   const sync=()=>buttons.forEach(button=>{const active=button.dataset.variant===select.value;button.setAttribute('aria-checked',String(active));button.tabIndex=active?0:-1;});
   choices.addEventListener('keydown',event=>{
    const keys=['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'];if(!keys.includes(event.key))return;event.preventDefault();
    let index=buttons.indexOf(document.activeElement);index=event.key==='Home'?0:event.key==='End'?buttons.length-1:(index+(event.key==='ArrowLeft'||event.key==='ArrowUp'?-1:1)+buttons.length)%buttons.length;
    buttons[index].focus();buttons[index].click();
   });
   select.addEventListener('change',sync);sync();select.hidden=true;if(label)label.hidden=true;select.after(field);
  });
 }
 function initialise(root=document){
  upgradeFaqs(root);
  upgradeVariantChoices(root);
  markReviewShells(root);
  // Converted legacy responsive sources still contain transparent builder placeholders.
  root.querySelectorAll('picture > source[srcset^="data:image/svg+xml"]').forEach(source=>{
   const image=source.parentElement.querySelector('img');
   if(image&&/^https?:/.test(image.getAttribute('src')||''))source.remove();
  });
  root.querySelectorAll('#MainContent details:not([data-ml-animated])').forEach(details=>{
   if(details.closest('.ml-filters,facet-filters-form,menu-drawer,details-modal,.mp-sort-control'))return;
   const summary=details.querySelector(':scope > summary');if(!summary)return;
   details.dataset.mlAnimated='true';details.dataset.mlMotion=details.open?'open':'closed';let expanded=details.open;
   const toggle=event=>{
    event.preventDefault();const from=details.getBoundingClientRect().height;expanded=!expanded;
    details.dataset.mlMotion=expanded?'opening':'closing';
    const previous=animations.get(details);if(previous){previous.onfinish=null;previous.cancel();animations.delete(details);}
    details.open=true;
    const to=expanded?details.getBoundingClientRect().height:summary.getBoundingClientRect().height+parseFloat(getComputedStyle(details).paddingTop||0)+parseFloat(getComputedStyle(details).paddingBottom||0)+parseFloat(getComputedStyle(details).borderTopWidth||0)+parseFloat(getComputedStyle(details).borderBottomWidth||0);
    summary.setAttribute('aria-expanded',String(expanded));
    animate(details,from,to,()=>{details.open=expanded;details.style.overflow='';details.dataset.mlMotion=expanded?'open':'closed';});
   };
   summary.addEventListener('click',toggle);
   summary.addEventListener('keydown',event=>{
    if(event.key==='Enter'||event.key===' '){event.preventDefault();toggle(event);}
   });
  });
  root.querySelectorAll('[data-native-accordion]:not([data-ml-animated])').forEach(header=>{
   const panel=document.getElementById(header.dataset.nativeAccordion);if(!panel)return;
   header.dataset.mlAnimated='true';let expanded=header.getAttribute('aria-expanded')==='true';
   const toggle=()=>{
    const from=panel.hidden?0:panel.getBoundingClientRect().height;expanded=!expanded;
    const previous=animations.get(panel);if(previous){previous.onfinish=null;previous.cancel();animations.delete(panel);}
    panel.hidden=false;header.setAttribute('aria-expanded',String(expanded));
    panel.setAttribute('aria-hidden',String(!expanded));panel.inert=!expanded;
    animate(panel,from,expanded?panel.getBoundingClientRect().height:0,()=>{panel.hidden=!expanded;panel.style.overflow='';});
   };
   header.addEventListener('click',toggle);
   if(!header.matches('button,summary,input,a[href]'))header.addEventListener('keydown',event=>{
    if(event.key==='Enter'||event.key===' '){event.preventDefault();toggle();}
   });
  });

 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialise());else initialise();
 document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();
